<div [id]="chartdiv_id" class="progressChart"></div>
